import { render, staticRenderFns } from "./ProductsWithCategory(old).vue?vue&type=template&id=16743655&"
import script from "./ProductsWithCategory(old).vue?vue&type=script&lang=js&"
export * from "./ProductsWithCategory(old).vue?vue&type=script&lang=js&"
import style0 from "./ProductsWithCategory(old).vue?vue&type=style&index=0&id=16743655&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports